import React, { useEffect, useState } from "react";
import {
  Col,
  Typography,
  Form,
  Select,
  DatePicker,
  TimePicker,
  Button,
  message,
  Row,
  Card,
  Modal,
  Tag,
  Switch,
  Tooltip,
  Spin,
} from "antd";
import {
  SettingOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { axiosInstance } from "../../utils/axiosInterceptor";
import HeaderCompo from "../../component/Header";

const { Title, Text } = Typography;
const { Option } = Select;

const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const SmsWorkflowNotification = ({  }) => {
  const [form] = Form.useForm();

  const [frequency, setFrequency] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [smsNotification,setSmsNotification] = useState([])
  const [isLoading, setLoading] = useState(false);
  const [notiType,setNotiType] = useState("");


  const getScheduleText = (item) => {
    const time = dayjs()
      .hour(item.hour)
      .minute(item.minute)
      .format("hh:mm A");

    if (item.frequency === "DAILY") return `Daily • ${time}`;
    if (item.frequency === "WEEKLY")
      return `${WEEK_DAYS[item?.day_of_week] || ""} • ${time}`;
    if (item.frequency === "MONTHLY")
      return `Day ${item.day_of_month} • ${time}`;
  };


  const handleSetup = () => {
    setIsEditMode(false);
    setSelectedNotification(null);
    setFrequency(null);
    form.resetFields();
    setNotiType(null)
  //   form.setFieldsValue({
  //   enabled: true, 
  // });
    setIsModalOpen(true);
  };

  const getSmsNotificationdata = async()=>{
      try {
        const response = await axiosInstance.get('/api/v2/powerbi/notification-schedules');
        console.log(response,"ApiRespnse")
        setSmsNotification(response?.data);
      } catch (error) {
        console.log(error,"Erroror")
      }
    }

  const handleEdit = (notification) => {
    setIsEditMode(true);
    setSelectedNotification(notification);
    setFrequency(notification.frequency);
    setNotiType(notification?.type)

    form.setFieldsValue({
      frequency: notification.frequency,
      sms_enabled: notification?.sms_enabled, 
      email_enabled:notification?.email_enabled,
      type: notification?.type,
      time: dayjs()
        .hour(notification.hour)
        .minute(notification.minute),
      day:
        notification.frequency === "WEEKLY"
          ? Number(notification.day_of_week)
          : notification.frequency === "MONTHLY"
          ? dayjs().date(notification.day_of_month)
          : null,
    });

    setIsModalOpen(true);
  };


  const handleFrequencyChange = (value) => {
    setFrequency(value);
    form.setFieldsValue({ day: null });
  };

    useEffect(() => {
      getSmsNotificationdata()
    }, []);

  const handleSubmit = async (values) => {
    const payload = {
      frequency: values.frequency,
      email_enabled: values?.email_enabled,
      sms_enabled:values?.sms_enabled,
      timezone: "Asia/Kolkata",
      hour: values.time.hour(),
      minute: values.time.minute(),
      type:values?.type
    };
    setLoading(true)
    if (values.frequency === "WEEKLY") {
      payload.day_of_week = values.day;
    }
    if (values.frequency === "MONTHLY") {
      payload.day_of_month = values.day.date();
    }

    try {
        await axiosInstance.post(
          `/api/v2/powerbi/notification-schedules`,
          payload
        );
        message.success("Notification added successfully");
      setIsModalOpen(false);
      getSmsNotificationdata();
    } catch (error) {
      console.error(error);
      message.error("Something went wrong");
    }
    finally{
      setLoading(false)
    }
  };

  const handleTypechange = (value)=>{
     setNotiType(value);
  }


  return (
     <div>
      <HeaderCompo initialColor={"#000833"} />
      <div className="p-6" style={{ padding: "16px 16px 0 16px" }}>
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold mb-4">Admin Notification Settings</h1>
        </div>
      <Card className="rounded-lg shadow-sm mb-4">
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={5} className="mb-0 flex items-center gap-2">
              {smsNotification?.length > 0 && (
                <CheckCircleOutlined style={{ color: "#52c41a" }} />
              )}
              Notification Settings
            </Title>
            <Text type="secondary">Configure SMS notification schedules</Text>
          </Col>

          <Col>
          {
            smsNotification?.length < 4 && (
            <Button type="primary" onClick={handleSetup}>
              Add Notification
            </Button>
            )
          }
          </Col>
        </Row>
      </Card>

      {smsNotification?.map((item) => (
        <Card
          key={item.id}
          size="small"
          className="mb-2"
          bodyStyle={{ padding: "10px 14px" }}
        >
          <Row justify="space-between" align="middle">
            <Col>
            <Row className="gap-2">
              <Text strong>{item?.type === "DOWNWARD_TREND" ?"TREND REVERSAL (GCR/ SGCR)" : item?.type?.replaceAll("_", " ")}</Text>
              <Tooltip title={item?.type === "DOWNWARD_TREND" ? "Triggers a daily alert when the data shows a consistent decline" : item?.type === "WEEKLY_PERFORMANCE" ?"Sends a weekly performance summary at the scheduled day and time" : "Sends a monthly GPR update based on the event triggered when the file is processed"}>
              <InfoCircleOutlined className="text-gray-600 hover:text-blue-600 cursor-pointer" style={{ fontSize:15 }} />
        </Tooltip>

            </Row>
              <div>
                <Tag color="blue">{item.frequency}</Tag>
                <Text type="secondary">{getScheduleText(item)}</Text>
              </div>
            </Col>

            <Col>
             {item?.sms_enabled ? (
                <Tag color="green">SMS Enabled</Tag>
              ) : (
                <Tag color="red">SMS Disabled</Tag>
              )}
              {item?.email_enabled ? (
                <Tag color="green">Email Enabled</Tag>
              ) : (
                <Tag color="red">Email Disabled</Tag>
              )}
              <Button
                size="small"
                icon={<SettingOutlined />}
                onClick={() => handleEdit(item)}
                className="mx-2"
              >
                Edit
              </Button>
            </Col>
          </Row>
        </Card>
      ))}

      <Modal
        title={isEditMode ? "Edit Notification" : "Add Notification"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        destroyOnClose
      >
      
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Row justify="space-between" className="flex items-center">
              <Text strong className="text-[16px] font-semibold  text-[#0b1538]" style={{marginTop:"-4px"}}>SMS Notification</Text>
          <Form.Item
            name="sms_enabled"
            valuePropName="checked"
            initialValue={true}
          >
              <Switch />
          </Form.Item>
            </Row>

            <Row justify="space-between" className="flex items-center">
              <Text strong className="text-[16px] font-semibold  text-[#0b1538]" style={{marginTop:"-4px"}}>Email Notification</Text>
          <Form.Item
            name="email_enabled"
            valuePropName="checked"
            initialValue={true}
          >
              <Switch />
          </Form.Item>
            </Row>
            <Form.Item
            label="Notification Type"
            name="type"
            rules={[{ required: true }]}
          >
            <Select placeholder={"Select Notification Type"} disabled={isEditMode} onChange={handleTypechange}>
              <Option value="WEEKLY_PERFORMANCE">WEEKLY PERFORMANCE</Option>
              <Option value="DOWNWARD_TREND">TREND REVERSAL (GCR/ SGCR)</Option>
              <Option value="GPR_UPDATE">GPR UPDATE</Option>
              <Option value="COGS_NOTIFICATION">COGS NOTIFICATION</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Frequency"
            name="frequency"
            rules={[{ required: true }]}
          >
            <Select placeholder={"Select frequency"} disabled={isEditMode} onChange={handleFrequencyChange}>
              {/* <Option value="DAILY">Daily</Option> */}
              <Option value="WEEKLY">Weekly</Option>
              <Option value="MONTHLY">Monthly</Option>
            </Select>
          </Form.Item>

          {frequency === "WEEKLY" && (
            <Form.Item name="day" label="Select Day" rules={[{ required: true }]}>
              <Select placeholder={"Select day"}>
                {WEEK_DAYS.map((d, i) => (
                  <Option key={i} value={i}>
                    {d}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {frequency === "MONTHLY" && (
            <Form.Item name="day" label="Select Date" rules={[{ required: true }]}>
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          )}

          <Form.Item name="time" label="Select Time" rules={[{ required: true }]}>
            <TimePicker use12Hours format="hh:mm A" style={{ width: "100%" }} />
          </Form.Item>

          <Button loading={isLoading} type="primary" htmlType="submit" block>
            {isEditMode ? "Update Notification" : "Save Notification"}
          </Button>
        </Form>
      </Modal>
      </div>
      </div>
  );
};

export default SmsWorkflowNotification;